import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, switchMap, take} from 'rxjs';

import {AuthenticationService} from '../service/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Ignorujeme požadavky, které nemají být autorizované
        if (request.url.startsWith("https://storage.googleapis.com")) {
            return next.handle(request);
        }

        // Použijeme reaktivní metodu pro získání tokenu
        return this.authenticationService.getCurrentUserToken().pipe(
            take(1),
            switchMap(token => {
                if (token) {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                }
                return next.handle(request);
            })
        );
    }
}
